
var React = require("react");
var ExternalLinkButton = require("./generic/ExternalLinkButton.jsx");
var ApplicationContext = require("../../config/ApplicationContext.js");
var EditorLaunchUtil = require("../../util/EditorLaunchUtil.js");

class NewPackageButton extends React.Component  {
    constructor(){
        super()
    }

    render(){
        return (
        	<ExternalLinkButton
                text="Create New Package"
                style={{marginBottom: "10px"}}
                onClick={()=>googleGA("send", "event", "packages", "newPackages")}
                link={EditorLaunchUtil.editorUrl(ApplicationContext.getPackageEditor(), { hub: this.props.idHub })}
            />
        );
    }
}

module.exports = NewPackageButton;
